export const getFifthAnalysesData = state => state.fifthAnalyses.all;
export const getFifthAnalysisData = state => state.fifthAnalyses.fifthAnalysis;
export const fifthAnalysesIsFetching = state => state.fifthAnalyses.loading.all;
export const fifthAnalysisIsFetching = state => state.fifthAnalyses.loading.fifthAnalysis;
